import React from 'react';
import { IRoute } from './AppRoutes';
import { Route } from 'react-router';
import { RouteSuspense } from './RouteSuspense';

export const BaseRoute: React.FC<IRoute> = (props) => {
  const {
    path,
    exact,
    component: Component,
    routes = [],
    ...otherProps
  } = props;

  return (
    <Route
      path={path}
      exact={typeof exact === 'undefined' ? true : exact}
      render={(otherComponentProps) => {
        return (
          <RouteSuspense>
            <Component routes={routes} {...otherComponentProps} />
          </RouteSuspense>
        );
      }}
      {...otherProps}
    />
  );
};
